import { render, staticRenderFns } from "./AddClocking.vue?vue&type=template&id=f5ddc9ea&scoped=true"
import script from "./AddClocking.vue?vue&type=script&lang=js"
export * from "./AddClocking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ddc9ea",
  null
  
)

export default component.exports